import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const AlignLeftIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AlignLeft",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.56 6.67h24.89c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56H3.56C2.7 3.55 2 4.25 2 5.11s.7 1.56 1.56 1.56M3.56 13.93h18.67c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56H3.56c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56M28.44 18.07H3.56c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56h24.89c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56ZM18.07 25.33H3.56c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56h14.52c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.14 7.14H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28M28.14 20.86H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28M16.71 14H3a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M16.71 27.71H3a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28"
      })
    })
  }));
};